'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var SvgStar = function (_a) {
    var testId = _a.testId, type = _a.type, restProps = tslib_es6.__rest(_a, ["testId", "type"]);
    switch (type) {
        case 'empty':
            return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 19 18", width: "100%", height: "100%", fill: "currentColor" }, restProps, { "data-testid": testId }),
                React__default['default'].createElement("path", { d: "M9.5 0l2.9 5.9 6.6 1-4.8 4.6 1.1 6.5-5.9-3-5.9 3 1.1-6.5L0 6.9 6.6 6l2.9-6zm0 2.3L7.2 6.9l-5 .7 3.7 3.6-.9 5 4.5-2.4 4.5 2.4-.9-5.1 3.7-3.6-5.1-.7-2.2-4.5z" })));
        case 'half':
            return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 19 18", width: "100%", height: "100%", fill: "currentColor" }, restProps, { "data-testid": testId }),
                React__default['default'].createElement("path", { d: "M9.5 0l2.9 5.9 6.6 1-4.8 4.6 1.1 6.5-5.9-3-5.9 3 1.1-6.5L0 6.9 6.6 6l2.9-6zm0 2.3v11.6l4.5 2.4-.9-5.1 3.7-3.6-5.1-.7-2.2-4.6z" })));
        case 'full':
            return (React__default['default'].createElement("svg", tslib_es6.__assign({ viewBox: "0 0 19 18", width: "100%", height: "100%", fill: "currentColor" }, restProps, { "data-testid": testId }),
                React__default['default'].createElement("path", { d: "M12.4 5.9L9.5 0 6.6 5.9 0 6.9l4.8 4.6L3.6 18l5.9-3 5.9 3-1.1-6.5L19 6.9l-6.6-1z" })));
        default:
            return React__default['default'].createElement(React__default['default'].Fragment, null);
    }
};

exports.default = SvgStar;
//# sourceMappingURL=index.js.map
